module.exports = __webpack_public_path__ + "static/media/club.6ae97b59.svg";